__turbopack_context__.v({
  "close": "O_Tu1G_close",
  "isVisible": "O_Tu1G_isVisible",
  "search": "O_Tu1G_search",
  "tabDrawer": "O_Tu1G_tabDrawer",
  "tabWrapper": "O_Tu1G_tabWrapper",
  "wrapper": "O_Tu1G_wrapper",
});
